module.exports = __webpack_public_path__ + "static/media/mcc-logo.bebf5c0b.jpg";